export const LocalStorageKey = Object.freeze({
	smileLastUpdateTime: 'smileLastUpdateTime',
	sidebarOpened: 'sidebarOpened',
	taskCommentsSidebarOpened: 'taskCommentsSidebarOpened',
	textareaMarketOpened: 'textareaMarketOpened',
	textareaHeight: 'textareaHeight',
	textareaHeightAiAssistantWidget: 'textareaHeightAiAssistantWidget',
	textareaHeightAiAssistantEmptyState: 'textareaHeightAiAssistantEmptyState',
	lastCallType: 'lastCallType',
	lastNotificationId: 'lastNotificationId',
	layoutConfig: 'layoutConfig',
	audioPlaybackRate: 'audioPlaybackRate',
	emotePopupTab: 'emotePopupTab',
	invitePopupTab: 'invitePopupTab',
	taskCommentsCardOpened: 'taskCommentsCardOpened',
	copilotWidgetLastDialogId: 'copilotWidgetLastDialogId',
	defaultReactionPending: 'defaultReactionPending',
});
